<template lang="pug">
  include /mixins
  +b.review--answer
    +e.top.--variant_answer
      +e.author
        +b.review-author.--space_none
          +e.img-wrap
            +e.img.IMG(
              :src='child.props.avatar || "/static/img/rebranding/non.png"'
            )
          +e.name.P {{ child.props.name }}
      +e.date.--space_none.P {{ child.props.created_at }}
    +e.content.--variant_answer
      template(
        v-if='child.props.original_lang && child.props.original_lang !== lang'
      )
        +e.body
          +b.t-content
            p(v-html='showTrans ? child.props.comment : child.props.translation_comment')
        +e.translation-actions
          +b.g-row.--space_lg.--appearance_spaced
            +b.g-cell.g-cols
              +b.tt-link.--styling_3(
                @click='showTrans = !showTrans'
              ) {{ showTrans ? _('Показать перевод') : _('Показать оригинал') }}
            +b.g-cell.g-cols(v-if='!showTrans')
              +b.ds-caption--size_xs.--size_sm-xl.--color_text-8.--medium.P {{_('Переведено автоматически')}}
      +e.body(v-else)
        +b.t-content
          p(v-html='child.props.comment')
</template>

<script>
export default {
  name: 'ReviewChildDetail',
  props: {
    child: {
      type: Object,
      default: () => {},
    },
    replier: {
      type: Function,
    },
    showMedia: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      lang: window.language,
      showTrans: false,
    };
  },
}
</script>
